'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/util/hyphenate.js
// module id = 1068
// module chunks = 0